import { GenericStatusByCall } from '../../enums/status-by-call';
import { SymbolAndOptionalExchangeCode } from '../../models/fundamental/types';

export enum AppCall {
  uploadUserPreferencesData,
  getUserPreferencesData,
}

export type UserPreferencesData = {
  favouriteStocks: SymbolAndOptionalExchangeCode[];
  recentlyViewedStocks: SymbolAndOptionalExchangeCode[];
  hasRequestedEuAccount?: boolean;
  hasSeenWelcomePopup?: boolean;
  hasSeenFirstDepositPopup?: boolean;
} & Record<string, any>;

export interface AppState {
  loaded: boolean;
  connected: boolean;
  isServicesReady: boolean;
  isWebLoginReady: boolean;
  isOnline: boolean;
  isConnectionSlow: boolean;
  isDemoExpirationModalDisplayed?: boolean;
  userPreferencesData: UserPreferencesData;
  statusByCall: GenericStatusByCall<AppCall>;
}
